import { formatMinutesExcel } from './../../utils/practiceUtils';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { makeSelectUsername } from 'store/app/selectors';
import { ResponseFetcher } from 'utils/fetcher/types';
import { ActionTypes } from './actionTypes';
import { makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected } from 'store/usuarios/selectors';
import { ExportExcelData } from 'store/practicas/types';
import { exportDataTableExcel } from 'utils/export-excel';
import { parseDateTime } from 'utils/parsePractices';
import {
  getEstadosCursosRequestSaga,
  getInfoUsersRequestSaga,
  getSociedadesRequestSaga,
} from 'store/app/sagas';
import {
  getInformeFilterAlumnosRequest,
  getInformeFilterCursosRequest,
  getInformeHorasCountRequest,
  getInformeHorasInstructorCountRequest,
  getInformeInfraestructuraCountRequest,
  getInformeInfraestructuraRequest,
  getInformeProvinciasRequest,
  getInformesHorasInstructorRequest,
  getInformesHorasRequest,
} from './requests';
import {
  setAllInformesCursosFilter,
  setAlumnosInforme,
  setEstadosInformes,
  setInformesCursosFilter,
  setInformesHoras,
  setInformesHorasCount,
  setInformesHorasInstructor,
  setInformesHorasInstructorCount,
  setInformesInfraestructura,
  setInformesInfraestructuraCount,
  setProvinciasInformes,
  setSociedadesInformes,
} from './actions';
import { makeSelectAllInformesCursosFilter } from './selectors';
import { addSingleQuotesToStudentsDniChain } from 'utils/practiceUtils';
import { getMonthName } from 'utils/dates-validators';

export default function* sagas() {
  // Informes horas
  yield takeLatest(
    [ActionTypes.GET_INFORMES_HORAS],
    getInformesHorasRequestSaga
  );
  yield takeLatest(
    [ActionTypes.GET_INFORMES_HORAS_COUNT],
    getInformeHorasCountRequestRequestSaga
  );
  yield takeLatest(
    [ActionTypes.GET_INFORMES_HORAS_EXCEL],
    getExcelInformesHorasRequestSaga
  );

  // Informes horas Instructor
  yield takeLatest(
    [ActionTypes.GET_INFORMES_HORAS_INSTRUCTOR],
    getInformesHorasInstructorRequestSaga
  );
  yield takeLatest(
    [ActionTypes.GET_INFORMES_HORAS_INSTRUCTOR_COUNT],
    getInformeHorasInstructorCountRequestRequestSaga
  );
  yield takeLatest(
    [ActionTypes.GET_INFORMES_HORAS_INSTRUCTOR_EXCEL],
    getExcelInformesHorasInstructorRequestSaga
  );

  // Informes infraestructura
  yield takeLatest(
    [ActionTypes.GET_INFORMES_INFRAESTRUCTURA],
    getInformesInfraestructuraRequestSaga
  );
  yield takeLatest(
    [ActionTypes.GET_INFORMES_INFRAESTRUCTURA_COUNT],
    getInformeInfraestructuraCountRequestRequestSaga
  );
  yield takeLatest(
    [ActionTypes.GET_INFORMES_INFRAESTRUCTURA_EXCEL],
    getExcelInformesInfraestructuraRequestSaga
  );

  // Filtros
  yield takeLatest(
    [ActionTypes.GET_SOCIEDADES_INFORMES],
    getSociedadesInformesRequestSaga
  );
  yield takeLatest(
    [ActionTypes.GET_PROVINCIAS_INFORMES],
    getProvinciasInformesRequestSaga
  );
  yield takeLatest(
    [ActionTypes.GET_CURSOS_INFORMES],
    getFilterCursosRequestSaga
  );
  yield takeLatest(
    [ActionTypes.GET_ALUMNOS_INFORMES],
    getFilterAlumnosRequestSaga
  );
  yield takeLatest(
    [ActionTypes.GET_ESTADOS_INFORMES],
    getEstadosCursosFilterRequestSaga
  );
}

// Informes horas

export function* informesHorasRequestSaga(params) {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );

  const payload: any = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,
    ...params,
  };

  payload.alumnos = addSingleQuotesToStudentsDniChain(payload.alumnos);

  const informesHorasResponse: ResponseFetcher<any> = yield call(
    getInformesHorasRequest,
    payload
  );
  const informesHoras = informesHorasResponse.data;

  const alumnosIds = informesHoras.map((item) => item.ID_ALUMNO).join(',');
  const infoUsersResponse: ResponseFetcher<any> = yield call(
    getInfoUsersRequestSaga,
    alumnosIds
  );
  const infoUsers = infoUsersResponse.data;

  const informesHorasParsed: any[] = [];

  informesHoras.forEach((informe) => {
    const user: any = infoUsers.find(
      (user: any) => user.ID_USUARIO === informe.ID_ALUMNO
    );

    informesHorasParsed.push({
      ...informe,
      nombre_parsed: user?.NOMBRE_USUARIO || '',
    });
  });

  return {
    ok: true,
    data: informesHorasParsed,
  };
}

export function* getInformesHorasRequestSaga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(
      informesHorasRequestSaga,
      params.payload
    );

    if (response.ok) {
      yield put(setInformesHoras(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_INFORMES_HORAS}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getInformeHorasCountRequestRequestSaga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: any = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      ...params.payload,
    };

    payload.alumnos = addSingleQuotesToStudentsDniChain(payload.alumnos);

    const response: ResponseFetcher<any> = yield call(
      getInformeHorasCountRequest,
      payload
    );

    if (response.ok) {
      yield put(setInformesHorasCount(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.SET_INFORMES_HORAS_COUNT}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getExcelInformesHorasRequestSaga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(
      informesHorasRequestSaga,
      { ...params.payload.filter, elemInicio: -1, elemFin: -1 }
    );
    const allInformesCursosFilter = yield select(
      makeSelectAllInformesCursosFilter()
    );

    const EXPORT_EXCEL: ExportExcelData = {
      headerExcelFile: [],
      bodyExcelFile: [],
      headerColumsConfig: [],
      title: 'listado_informes_horas_' + new Date().getTime().toString(),
    };

    params.payload.excelConfig.literals.forEach((item) => {
      EXPORT_EXCEL.headerExcelFile.push(item.text);
      EXPORT_EXCEL.headerColumsConfig.push({
        label: item.text,
        key: item.text,
        width: 30,
      });
    });

    response.data.forEach((item) => {
      const itemArray = [
        item.ID_CURSO,
        allInformesCursosFilter.find(
          (curso) => curso.ID_CURSO === Number(item.ID_CURSO)
        )?.NOMBRE_CURSO,
        item.ID_ALUMNO,
        item.nombre_parsed,
        parseDateTime(new Date(Number(item.FECHA_INI_JORNADA))),
        parseDateTime(new Date(Number(item.FECHA_FIN_JORNADA))),
        formatMinutesExcel(item.HORAS_VALIDADAS_CONDUCCION_EFECTIVA),
        formatMinutesExcel(item.HORAS_PENDIENTES_VALIDAR_CONDUCCION_EFECTIVA),
        formatMinutesExcel(item.HORAS_VALIDADAS_OTRAS),
        formatMinutesExcel(item.HORAS_PENDIENTES_VALIDAR_OTRAS),
      ];

      EXPORT_EXCEL.bodyExcelFile.push(itemArray);
    });

    exportDataTableExcel(
      EXPORT_EXCEL.headerExcelFile,
      EXPORT_EXCEL.bodyExcelFile,
      EXPORT_EXCEL.headerColumsConfig,
      EXPORT_EXCEL.title
    );
  } catch (err) {
    console.error(err);
  }
}

// Informes horas Instructor

export function* informesHorasInstructorRequestSaga(params) {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );

  const payload: any = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,
    ...params,
  };

  const informesHorasInstructorsResponse: ResponseFetcher<any> = yield call(
    getInformesHorasInstructorRequest,
    payload
  );

  const informesHorasInstructors = informesHorasInstructorsResponse.data;

  const instructorsIds = informesHorasInstructors
    .map((item) => item.ID_INSTRUCTOR)
    .join(',');
  const infoUsersResponse: ResponseFetcher<any> = yield call(
    getInfoUsersRequestSaga,
    instructorsIds
  );
  const infoUsers = infoUsersResponse.data;

  const informesHorasParsed: any[] = [];
  informesHorasInstructors.forEach((informe) => {
    const user: any = infoUsers.find(
      (user: any) => user.ID_USUARIO === informe.ID_INSTRUCTOR
    );

    informesHorasParsed.push({
      ...informe,
      nombre_parsed: user?.NOMBRE_USUARIO || '',
    });
  });

  return {
    ok: true,
    data: informesHorasParsed,
  };
}

export function* getInformesHorasInstructorRequestSaga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(
      informesHorasInstructorRequestSaga,
      params.payload
    );

    if (response.ok) {
      yield put(setInformesHorasInstructor(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_INFORMES_HORAS}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getInformeHorasInstructorCountRequestRequestSaga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: any = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      ...params.payload,
    };

    const response: ResponseFetcher<any> = yield call(
      getInformeHorasInstructorCountRequest,
      payload
    );

    if (response.ok) {
      yield put(setInformesHorasInstructorCount(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.SET_INFORMES_HORAS_COUNT}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getExcelInformesHorasInstructorRequestSaga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(
      informesHorasInstructorRequestSaga,
      { ...params.payload.filter, elemInicio: -1, elemFin: -1 }
    );

    const EXPORT_EXCEL: ExportExcelData = {
      headerExcelFile: [],
      bodyExcelFile: [],
      headerColumsConfig: [],
      title:
        'listado_informes_horas_instructor_' + new Date().getTime().toString(),
    };

    params.payload.excelConfig.literals.forEach((item) => {
      EXPORT_EXCEL.headerExcelFile.push(item.text);
      EXPORT_EXCEL.headerColumsConfig.push({
        label: item.text,
        key: item.text,
        width: 30,
      });
    });

    response.data.forEach((item) => {
      const itemArray = [
        getMonthName(item.MES) + ' ' + item.ANYO,
        item.ID_INSTRUCTOR,
        item.nombre_parsed,
        formatMinutesExcel(item.SUMATORIO_VA),
        formatMinutesExcel(item.SUMATORIO_PV),
        formatMinutesExcel(item.SUMATORIO_TM),
        formatMinutesExcel(item.TOTAL_TIEMPO),
        item.MESSAGE_INFO,
      ];

      EXPORT_EXCEL.bodyExcelFile.push(itemArray);
    });

    exportDataTableExcel(
      EXPORT_EXCEL.headerExcelFile,
      EXPORT_EXCEL.bodyExcelFile,
      EXPORT_EXCEL.headerColumsConfig,
      EXPORT_EXCEL.title
    );
  } catch (err) {
    console.error(err);
  }
}

// Informes infraestructura

export function* informesInfraestructuraRequestSaga(params) {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );

  const payload: any = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,
    alumnos: '',
    ascDesc: '',
    cursos: '',
    elemFin: 10,
    elemInicio: 0,
    estadosCurso: '',
    fechaFin: '',
    fechaInicio: '',
    orden: '',
    provincias: '',
    sociedades: '',
    ...params,
  };

  payload.alumnos = addSingleQuotesToStudentsDniChain(payload.alumnos);

  const informesInfraestructuraResponse: ResponseFetcher<any> = yield call(
    getInformeInfraestructuraRequest,
    payload
  );
  const informesInfraestructura = informesInfraestructuraResponse.data;
  const alumnosIds = informesInfraestructura
    .map((item) => item.ID_ALUMNO)
    .join(',');
  const infoUsersResponse: ResponseFetcher<any> = yield call(
    getInfoUsersRequestSaga,
    alumnosIds
  );
  const infoUsers = infoUsersResponse.data;

  const informesInfraestructuraParsed: any[] = [];

  informesInfraestructura.forEach((informe) => {
    const user: any = infoUsers.find(
      (user: any) => user.ID_USUARIO === informe.ID_ALUMNO
    );

    if (user) {
      informesInfraestructuraParsed.push({
        ...informe,
        nombre_parsed: user.NOMBRE_USUARIO,
      });
    }
  });

  return {
    ok: true,
    data: informesInfraestructuraParsed,
  };
}

export function* getInformesInfraestructuraRequestSaga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(
      informesInfraestructuraRequestSaga,
      params.payload
    );

    if (response.ok) {
      yield put(setInformesInfraestructura(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_INFORMES_INFRAESTRUCTURA}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getInformeInfraestructuraCountRequestRequestSaga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: any = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      ...params.payload,
    };

    payload.alumnos = addSingleQuotesToStudentsDniChain(payload.alumnos);

    const response: ResponseFetcher<any> = yield call(
      getInformeInfraestructuraCountRequest,
      payload
    );

    if (response.ok) {
      yield put(setInformesInfraestructuraCount(response.data));
    } else {
      throw new Error(
        `Error: ${ActionTypes.GET_INFORMES_INFRAESTRUCTURA_COUNT}`
      );
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getExcelInformesInfraestructuraRequestSaga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(
      informesInfraestructuraRequestSaga,
      {
        ...params.payload.filter,
        elemInicio: -1,
        elemFin: -1,
        elemFinal: -1,
      }
    );

    const EXPORT_EXCEL: ExportExcelData = {
      headerExcelFile: [],
      bodyExcelFile: [],
      headerColumsConfig: [],
      title: 'infraestructura_' + new Date().getTime().toString(),
    };

    params.payload.excelConfig.literals.forEach((item) => {
      EXPORT_EXCEL.headerExcelFile.push(item.text);
      EXPORT_EXCEL.headerColumsConfig.push({
        label: item.text,
        key: item.text,
        width: 30,
      });
    });

    const allInformesCursosFilter = yield select(
      makeSelectAllInformesCursosFilter()
    );

    response.data.forEach((item) => {
      const itemArray = [
        item.ID_CURSO,
        allInformesCursosFilter.find(
          (curso) => curso.ID_CURSO.toString() === item.ID_CURSO
        ).NOMBRE_CURSO,
        item.ID_ALUMNO,
        item.nombre_parsed,
        item.TRAYECTO,
        item.TRAYECTO_VALIDADO,
        item.TRAYECTO_PENDIENTE_VALIDAR,
        formatMinutesExcel(item.HORAS_VALIDADAS_CONDUCCION_EFECTIVA),
        formatMinutesExcel(item.HORAS_PENDIENTES_VALIDAR_CONDUCCION_EFECTIVA),
        formatMinutesExcel(item.HORAS_VALIDADAS_OTRAS),
        formatMinutesExcel(item.HORAS_PENDIENTES_VALIDAR_OTRAS),
      ];

      EXPORT_EXCEL.bodyExcelFile.push(itemArray);
    });

    exportDataTableExcel(
      EXPORT_EXCEL.headerExcelFile,
      EXPORT_EXCEL.bodyExcelFile,
      EXPORT_EXCEL.headerColumsConfig,
      EXPORT_EXCEL.title
    );
  } catch (err) {
    console.error(err);
  }
}

// Filtros

export function* getSociedadesInformesRequestSaga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(
      getSociedadesRequestSaga,
      params.payload
    );

    if (response.ok) {
      yield put(setSociedadesInformes(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_SOCIEDADES_INFORMES}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getProvinciasInformesRequestSaga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: any = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      cursos: '',
      sociedades: '',
      ...params.payload,
    };

    const response: ResponseFetcher<any> = yield call(
      getInformeProvinciasRequest,
      payload
    );

    if (response.ok) {
      yield put(setProvinciasInformes(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_PROVINCIAS_INFORMES}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getEstadosCursosFilterRequestSaga(params) {
  try {
    const saved = JSON.parse(
      sessionStorage.getItem('savedEstadosInformes') || '{"isSaved": false}'
    );

    if (saved.isSaved === undefined) {
      yield put(setEstadosInformes(saved));
    } else {
      const response: ResponseFetcher<any> = yield call(
        getEstadosCursosRequestSaga /* , params.payload */
      );

      if (response.ok) {
        sessionStorage.setItem(
          'savedEstadosInformes',
          JSON.stringify(response.data)
        );
        yield put(setEstadosInformes(response.data));
      } else {
        throw new Error(`Error: ${ActionTypes.GET_ESTADOS_INFORMES}`);
      }
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getFilterCursosRequestSaga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const allInformesCursosFilter = yield select(
      makeSelectAllInformesCursosFilter()
    );

    const payload: any = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      sociedades: '',
      provincias: '',
      ...params.payload,
    };

    const response: ResponseFetcher<any> = yield call(
      getInformeFilterCursosRequest,
      payload
    );

    if (response.ok) {
      yield put(setInformesCursosFilter(response.data));

      if (!allInformesCursosFilter.length) {
        yield put(setAllInformesCursosFilter(response.data));
      }
    } else {
      throw new Error(`Error: ${ActionTypes.GET_CURSOS_INFORMES}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getFilterAlumnosRequestSaga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: any = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      sociedades: '',
      cursos: '',
      provincias: '',
      ...params.payload,
    };

    const response: ResponseFetcher<any> = yield call(
      getInformeFilterAlumnosRequest,
      payload
    );

    if (response.ok) {
      yield put(setAlumnosInforme(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_ALUMNOS_INFORMES}`);
    }
  } catch (err) {
    console.error(err);
  }
}
